module.exports = __webpack_public_path__ + "img/2.f6cc6e1b.jpg";